import angular from 'angular';
import settingsModule from '../../settings.module';
import template from './permission.component.html';
import style from './permission.component.css';

export default settingsModule.component('permission', {
    template,
    style,
    controller($q, $sessionStorage, asLoadingMask, asNotifier, accountProvider, permissionService, textResources, userTypeConstants) {
        var vm = this;

        vm.options = {
            pasteSplitPattern: '[,; ]',
            placeholder: textResources.enterUsersHere
        };
        vm.supportPermissions = [];
        vm.supportManagementPermissions = [];
        vm.accountUsers = [];
        vm.selectedUserPermissions = [];
        vm.selectedSupports = [];
        vm.totalSupportMaxUsers = 0;
        vm.remainingSupports = 0;
        vm.totalSupportMaxUsersDisplay = 'users';
        vm.totalSupportMaxAdminsDisplay = 'admins';
        vm.remainingUsersDisplay = 'users';
        vm.remainingAdminsDisplay = 'admins';
        vm.isWithinSupportLimit = true;
        vm.readyToDisplay = false;
        vm.selectedSupportUsers = [];
        vm.selectedSupportAdmins = [];
        vm.originalSelectedUsers = [];
        vm.originalSelectedAdmins = [];

        vm.$onInit = () => {
            asLoadingMask.show();

            var supportPermissionsIndex = 0;
            var usersIndex = 1;
            var supportUserPermissionsIndex = 2;
            var accountPlanIndex = 3;
            var supportAdminPermissionsIndex = 4;
            var supportManagementPermissionsIndex = 5;

            var promises = [
                permissionService.getPermissions('support'),
                permissionService.getUsersOfAccount('', userTypeConstants.user),
                permissionService.getUserPermissionsOfAccount('support'),
                accountProvider.getAccountPlan(),
                permissionService.getUserPermissionsOfAccount('supportmanagement'),
                permissionService.getPermissions('supportmanagement')
            ];

            $q.all(promises).then(
                data => {
                    let supportPermissions = data[supportPermissionsIndex];
                    let users = data[usersIndex];
                    let supportUserPermissions = data[supportUserPermissionsIndex];
                    let accountPlan = data[accountPlanIndex];
                    let supportAdminPermissions = data[supportAdminPermissionsIndex];
                    let supportManagementPermissions = data[supportManagementPermissionsIndex];

                    if (supportPermissions && supportPermissions.items) {
                        vm.supportPermissions = supportPermissions.items;
                    }

                    if (supportManagementPermissions && supportManagementPermissions.items) {
                        vm.supportManagementPermissions = supportManagementPermissions.items;
                    }

                    if (!users || !users.items || !accountPlan) {
                        asLoadingMask.hide();
                        return;
                    }

                    vm.accountUsers = users.items.reduce((obj, item) => {
                        if (item.id != $sessionStorage.userGuid) {
                            obj[item.id] = item;
                        }
                        return obj;
                    }, {});

                    if (supportUserPermissions && supportUserPermissions.items) {
                        let unique = {};
                        vm.selectedSupportUsers = [];

                        supportUserPermissions.items.map(userPermission => {
                            if (!unique[userPermission.userId]) {
                                unique[userPermission.userId] = true;
                                if (vm.accountUsers[userPermission.userId]) {
                                    let user = angular.copy(vm.accountUsers[userPermission.userId]);
                                    user.text = joinUserFirstNameAndLastName(user) || user.username;
                                    vm.selectedSupportUsers.push(user);
                                }
                            }
                        });

                        vm.originalSelectedUsers = angular.copy(vm.selectedSupportUsers);
                    } else {
                        vm.originalSelectedUsers = [];
                    }

                    if (supportAdminPermissions && supportAdminPermissions.items) {
                        let unique = {};
                        vm.selectedSupportAdmins = [];

                        supportAdminPermissions.items.map(userPermission => {
                            if (!unique[userPermission.userId]) {
                                unique[userPermission.userId] = true;
                                if (vm.accountUsers[userPermission.userId]) {
                                    let user = angular.copy(vm.accountUsers[userPermission.userId]);
                                    user.text = joinUserFirstNameAndLastName(user) || user.username;
                                    vm.selectedSupportAdmins.push(user);
                                }
                            }
                        });

                        vm.originalSelectedAdmins = angular.copy(vm.selectedSupportAdmins);
                    } else {
                        vm.originalSelectedAdmins = [];
                    }

                    vm.totalSupportMaxUsers = accountPlan.metadata.supportMaxusers || accountPlan.metadata.licenseMaxusers;

                    vm.totalSupportMaxUsersDisplay = getUserTextDisplay(vm.totalSupportMaxUsers);

                    vm.totalSupportMaxAdminsDisplay = getAdminTextDisplay(vm.totalSupportMaxUsers);

                    vm.totalSupportMaxUsersExcludeOwner = vm.totalSupportMaxUsers - 1;

                    changeRemainingUserDisplay(getCurrentTotalSupport());

                    vm.remainingUsersDisplay = getUserTextDisplay(vm.remainingSupports);

                    vm.remainingAdminsDisplay = getAdminTextDisplay(vm.remainingSupports);

                    if (getCurrentTotalSupport() >= vm.totalSupportMaxUsersExcludeOwner) {
                        vm.isWithinSupportLimit = false;
                    }

                    vm.readyToDisplay = true;
                    asLoadingMask.hide();
                },
                () => {
                    asNotifier.error(`${textResources.genericError} ${textResources.ifProblemPersists}`);
                    asLoadingMask.hide();
                }
            );
        };

        vm.filterTags = $query => {
            var accountUsers = Object.keys(vm.accountUsers)
                .map(userId => {
                    var user = vm.accountUsers[userId];

                    user.text = `${joinUserFirstNameAndLastName(user)} ${user.username}`;
                    return user;
                })
                .filter(user => user.text.includes($query))
                .sort((a, b) => {
                    if (a.firstName) {
                        return b.firstName ? a.firstName.localeCompare(b.firstName) : 1;
                    }
                    return b.firstName ? -1 : a.username.localeCompare(b.username);
                });

            return $q.resolve(accountUsers);
        };

        vm.tagAdding = tag => {
            var names = [];
            if (tag.firstName) {
                names.push(tag.firstName);
            }
            if (tag.lastName) {
                names.push(tag.lastName);
            }
            tag.text = names.join(' ') || tag.username;
        };

        vm.hasChanges = () => {
            changeRemainingUserDisplay(getCurrentTotalSupport());
            vm.remainingUsersDisplay = getUserTextDisplay(vm.remainingSupports);
            vm.remainingAdminsDisplay = getAdminTextDisplay(vm.remainingSupports);

            if (getCurrentTotalSupport() >= vm.totalSupportMaxUsersExcludeOwner) {
                vm.isWithinSupportLimit = false;

                if (getCurrentTotalSupport() > vm.totalSupportMaxUsersExcludeOwner) {
                    return false;
                }
            } else {
                vm.isWithinSupportLimit = true;
            }

            if (vm.selectedSupportUsers != vm.originalSelectedUsers.length) {
                return true;
            }

            if (vm.selectedSupportAdmins != vm.originalSelectedAdmins.length) {
                return true;
            }

            var originalSelectedUsers = vm.originalSelectedUsers.reduce((obj, item) => {
                obj[item.id] = item;
                return obj;
            }, {});

            for (let index in vm.selectedSupportUsers) {
                if (!originalSelectedUsers[vm.selectedSupportUsers[index].id]) {
                    return true;
                }
            }

            var originalSelectedAdmins = vm.originalSelectedAdmins.reduce((obj, item) => {
                obj[item.id] = item;
                return obj;
            }, {});

            for (let index in vm.selectedSupportAdmins) {
                if (!originalSelectedAdmins[vm.selectedSupportAdmins[index].id]) {
                    return true;
                }
            }

            return false;
        };

        vm.tagAddedUser = () => {
            if (getCurrentTotalSupport() >= vm.totalSupportMaxUsers) {
                vm.selectedSupportUsers.pop();
            }

            vm.hasChanges();
        };

        vm.tagAddedAdmin = () => {
            if (getCurrentTotalSupport() >= vm.totalSupportMaxUsers) {
                vm.selectedSupportAdmins.pop();
            }

            vm.hasChanges();
        };

        vm.tagRemoved = () => {
            vm.hasChanges();
        };

        vm.resetForm = () => {
            vm.$onInit();
            vm.supportUserText = '';
            vm.supportAdminText = '';
            vm.permissionForm.$setPristine();
        };

        vm.createUserPermissions = () => {
            if (!vm.supportPermissions || !vm.supportManagementPermissions || vm.permissionForm.$invalid) {
                return;
            }

            asLoadingMask.show();

            var userPermissionsToBeCreated = [];

            vm.selectedSupportUsers.map(user => {
                vm.supportPermissions.map(permission => {
                    if (user.id && permission.id) {
                        userPermissionsToBeCreated.push({
                            userId: user.id,
                            permissionId: permission.id
                        });
                    }
                });
            });

            vm.selectedSupportAdmins.map(user => {
                vm.supportManagementPermissions.map(permission => {
                    if (user.id && permission.id) {
                        userPermissionsToBeCreated.push({
                            userId: user.id,
                            permissionId: permission.id
                        });
                    }
                });
            });

            permissionService
                .createUserPermissions(userPermissionsToBeCreated)
                .then(
                    () => {
                        asNotifier.success(textResources.userPermissionsAdded);
                    },
                    () => {
                        asNotifier.error(`${textResources.genericError} ${textResources.ifProblemPersists}`);
                    }
                )
                .finally(() => {
                    asLoadingMask.hide();
                    vm.resetForm();
                });
        };

        function joinUserFirstNameAndLastName(user) {
            var names = [];
            if (user.firstName) {
                names.push(user.firstName);
            }
            if (user.lastName) {
                names.push(user.lastName);
            }
            return names.join(' ');
        }

        function changeRemainingUserDisplay(selectedUserLength) {
            vm.remainingSupports = vm.totalSupportMaxUsersExcludeOwner - selectedUserLength;
        }

        function getUserTextDisplay(numberOfUsers) {
            return numberOfUsers > 1 ? 'users' : 'user';
        }

        function getAdminTextDisplay(numberOfUsers) {
            return numberOfUsers > 1 ? 'admins' : 'admin';
        }

        function getCurrentTotalSupport() {
            let filteredAdmins = vm.selectedSupportAdmins.filter(admin => {
                return !vm.selectedSupportUsers.some(user => user.id === admin.id);
            });

            return vm.selectedSupportUsers.length + filteredAdmins.length;
        }
    }
});



// WEBPACK FOOTER //
// ./modules/settings/components/permission/permission.component.js